const AREA_TITLES = [
	"Roles", "Habits", "Personal causation", "Values", "Interests", "Skills",
	"Short-term goals", "Long-term goals", "Interpretation of past experiences",
	"Physical environment", "Social environment", "Readiness for change",
]

export function createOcairsConfig() {
	return {
		title: "OCAIRS occupational adaptation profile",
		instructions: "Record the interview information, your observations, and your interpretation separately. Rate each area only when the available information supports a rating.",
		validateFormAnswers: true,
		ordinalProfile: {
			sections: AREA_TITLES.map((title, index) => ({id: `area_${index + 1}`, title, items: [{id: `rating_${index + 1}`, title, question: title, guidance: ""}]})),
			options: [
				{id: "restricts", title: "Restricts", value: 1, explanation: "Restricts occupational participation"},
				{id: "inhibits", title: "Inhibits", value: 2, explanation: "Inhibits occupational participation"},
				{id: "allows", title: "Allows", value: 3, explanation: "Allows occupational participation"},
				{id: "facilitates", title: "Facilitates", value: 4, explanation: "Facilitates occupational participation"},
			],
			ratingScaleMax: 4,
			ratingPresentation: "stars",
			allowPartialCompletion: true,
			maxUnrated: 12,
			informationSources: true,
			dateLabel: "Assessment date",
			assessorLabel: "Practitioner",
			environmentLabel: "Assessment context",
			analysisLabel: "Overall practitioner interpretation",
			commentLabel: "Area notes",
			completedLabel: "All areas rated",
			incompleteLabel: "Partial profile",
			reportedLabel: "Client-reported information",
			observedLabel: "Practitioner observations",
			sourceLimitLabel: "Source limitations",
			interpretationLabel: "Practitioner interpretation",
			supportsLabel: "Supports",
			barriersLabel: "Barriers",
			patternsLabel: "Participation patterns",
			profileModeLabel: "Profile type",
			newModeLabel: "New profile",
			followUpModeLabel: "Follow-up profile",
			unverifiedContentLabel: "Interview questions and area-specific rating criteria have not been configured.",
		},
	}
}

export function createOcairsDemoPayload() {
	return {answers: {
		assessmentDate: "2026-10-29", assessor: "Mara Hoffmann", environment: "Outpatient occupational therapy", profileMode: "new",
		rating_1: "inhibits", rating_1Reported: "I still prepare meals for my family, but the evening routine often runs late.",
		rating_1Observed: "Described the family role clearly and identified a recurring timing difficulty.",
		rating_1Interpretation: "The family role remains meaningful; routine disruption limits consistent participation.",
		rating_1Supports: "Strong commitment to family meals", rating_1Barriers: "Evening fatigue", rating_1Patterns: "Participation is more consistent on weekends.",
		rating_10: "facilitates", rating_10Reported: "The kitchen layout makes food preparation manageable.",
		analysis: "Family participation is supported by a meaningful role and an accessible kitchen. Evening fatigue and timing remain barriers to consistent meals.",
	}}
}
